(function() {
    angular
      .module('meanApp')
      .controller('searchCtrl', searchCtrl);
  
      searchCtrl.$inject = [
        '$scope',
        '$rootScope', 
        '$window',
        '$location', 
        'authentication', 
        'loginModal', 
        'context', 
        '$state', 
        '$stateParams',
        'recipesManager',
        'searchData', 
        'ingredientsManager',
        'allergensManager', 
        '$q',
        'alert', 
        'currentUser', 
        'utils'];
        function searchCtrl(
            $scope, 
            $rootScope,
            $window,
            $location, 
            authentication, 
            loginModal, 
            context, 
            $state, 
            $stateParams,
            recipesManager,
            searchData,
            ingredientsManager,
            allergensManager,
            $q,
            alertMatt,
            currentUser,
            utils
            ) {
            
            var vm = this,
            LIMIT_FETCH = 6;
            
            //init the controller only once
            vm.currentCompletion = parseInt($stateParams.step)*100/3;
            vm.widthProgressBar = {
                width: vm.currentCompletion+'%' 
            };
            vm.tagsSelectedModalOpen = false;
            vm.isHelpDisplayed = false;
            vm.mustDisplayHelp =  $window.localStorage['searchHelp'] !== 'false';
            vm.tags = searchData.getTags();
            vm.tagsSelected = searchData.getTagsSelected();
            vm.recipesCount = searchData.getRecipesCount();
            vm.ingredients = [];
            vm.odNumberRecipes = null;
            vm.allergens= [];
            vm.listAllergensForCurrentUser = [];
            vm.ingredientsLikedArray = [];
            vm.ingredientsLikeModalOpen = false;
            vm.currentIngredientPage = 1;
            vm.currentIngredientDislikePage = 1;
            vm.isTypeAheadLoading = false;
            vm.searchCurrentPage = 1;
            vm.recipesResults = [];
            vm.thumbRecipesResults = [];
            $scope.$state = $state;
            vm.beingFetched = true;
 
            //must be true if user is not connected 
            //vm.noAccount = !authentication.isLoggedIn();
            //authentication is LoggedIn is not enough
            currentUser.get().then(function(userModel) {
                vm.noAccount = !(userModel && userModel._id);
            }, function() {
                vm.noAccount = true;
            });

            this._getContextName = function() {
                var stepNumber = parseInt($stateParams.step),
                contextName = '';

                if(stepNumber<4) {
                    contextName = 'Recherche ' + stepNumber+'/3';
                }
                else if (stepNumber === 4) {
                    contextName = 'Personnalisation';
                }
                else {
                    contextName = 'Résultats de recherche';
                }

                return contextName;
            };

            this._getTitle = () => {
                let title = '',
                stepNumber = parseInt($stateParams.step);

                switch(stepNumber) {
                    case 1 : title = 'Recherche de recettes selon vos envies: type de plat, sucré, salé, chaud, froid'; break;
                    case 2 : title = 'Recherche de recettes selon votre mode de vie: végétarien, paléo, hyperprotéiné, hypocalorique'; break;
                    case 3 : title = 'Recherche de recettes selon vos contraintes: économique, rapide, sans four'; break;
                    case 4 : title = 'Personnalisation de vos recettes selon vos allergies et préférences culinaires'; break;
                    default : title = 'Résultats de recherche de recette selon les Nutritags'; break;
                }

                return title;
            };

            this._getNextHref = function() {
                var stepNumber = parseInt($stateParams.step);
                return '/recherche/etape/'+ (stepNumber+1);
            };

            this._goToPreviousStep = function() {
                var stepNumber = parseInt($stateParams.step);
                if(stepNumber>1 && stepNumber< 5) {
                    $state.go('recipeSearchStep', {
                        step: stepNumber-1
                    });
                }
            };

            this.goToStep = function(number) {
                $state.go('recipeSearchStep', {
                    step: parseInt(number)
                });
            };

            this._goToNextStep = function() {
                var stepNumber = parseInt($stateParams.step);
                if(stepNumber<4) {
                    $state.go('recipeSearchStep', {
                        step: stepNumber+1
                    });
                }
                else {
                    vm.gotoSearchResults();
                }
            };


            // Returns a function, that, as long as it continues to be invoked, will not
            // be triggered. The function will be called after it stops being called for
            // N milliseconds. If `immediate` is passed, trigger the function on the
            // leading edge, instead of the trailing.
            var debounce = function(func, wait, immediate) {
                var timeout;
                return function() {
                    var context = this, args = arguments;
                    var later = function() {
                        timeout = null;
                        if (!immediate) func.apply(context, args);
                    };
                    var callNow = immediate && !timeout;
                    clearTimeout(timeout);
                    timeout = setTimeout(later, wait);
                    if (callNow) func.apply(context, args);
                };
            };

            

            //this function is finally called to take into account
            //- the tags, 
            //- the ingredients liked
            //- the ingredients disliked
            //- the allergens (TODO last)
            var NUMBER_ITEM_PER_ROW = 2;
            this._getAdvancedSearchResultsToBeDebounced = function() {
                var nbResultsLoaded = vm.searchCurrentPage === 1 ? vm.recipesResults.length : (vm.thumbRecipesResults.length + 1);
                vm.beingFetched = true;
                //if user not connected trigger usual non advanced search results
                currentUser.get().then(function(userModel) {
                    //here check for the cache
                    var cachedData = searchData.getCache(vm.tagsSelected, vm.searchCurrentPage);
                    if(cachedData && !$stateParams.search) {
                        //console.log('data cached is', searchData.getCache(vm.tagsSelected, vm.searchCurrentPage));
                        vm.searchCurrentPage = cachedData.currentPage;
                        
                        vm.recipesResults = cachedData.recipes;//init the array
                        vm.thumbRecipesResults = vm.recipesResults.filter(function(recipe, index) {
                            return index > 0;
                        });

                        nbResultsLoaded = vm.searchCurrentPage === 1 ? vm.recipesResults.length : (vm.thumbRecipesResults.length + 1);
                        vm.hideLoadMore = nbResultsLoaded === cachedData.totalCount;//hide if there is no more content to be displayed

                        if (vm.recipesResults.length === 0) {
                            vm.hideLoadMore = true;
                            vm.zeroResult = true;
                        }
                        searchData.setRecipeCount(cachedData.totalCount);
                        vm.updateCountOdometer();
                        vm.beingFetched = false;
                    }
                    else {
                        var searchParam = vm.tagsSelected.length > 0 ? vm.tagsSelected : [vm.textSearch];
                        recipesManager.searchRecipesAdvanced(searchParam, vm.searchCurrentPage)
                        .then(function(recipes) {
                            
                            if(userModel && userModel._id) {
                                recipes.docs.forEach(function(recipe) {
                                    vm.extractMatchedIngredients(recipe, userModel);
                                });
                            }
                            else {
                                //just perform a simple prefetch call to have nice data in cache
                                recipes.docs.forEach(function(recipe) {
                                    //perform call only if model is not complete
                                    var forceCall = !recipe.isModelComplete();
                                    //force call if imcomplete
                                    recipesManager.get(recipe.slug, forceCall);
                                });
                            }

                            //if first page init the arrray, otherwise push it in the array
                            if(vm.searchCurrentPage === 1) {
                                vm.recipesResults = recipes.docs;//init the array
                                vm.thumbRecipesResults = vm.recipesResults.filter(function(recipe, index) {
                                    return index > 0;
                                });
                            }
                            else {
                                vm.thumbRecipesResults = vm.thumbRecipesResults.concat(recipes.docs);
                            }

                            nbResultsLoaded = vm.searchCurrentPage === 1 ? vm.recipesResults.length : (vm.thumbRecipesResults.length + 1);
                            vm.hideLoadMore = nbResultsLoaded === recipes.total;//hide if there is no more content to be displayed
                            
                            if (vm.recipesResults.length === 0) {
                                vm.zeroResult = true;
                                vm.hideLoadMore = true;
                            }
                            vm.recipesCount = recipes.total;
                            searchData.setCache(vm.tagsSelected, vm.searchCurrentPage, vm.recipesCount,  recipes.docs);
                            searchData.setRecipeCount(vm.recipesCount);
                            vm.updateCountOdometer();
                            vm.beingFetched = false;
                        });
                    }
                });
            };

            this._getAdvancedSearchResults = debounce(this._getAdvancedSearchResultsToBeDebounced, 250);

            ////extract ingredients from recipe that match the request
            vm.extractMatchedIngredients = function(recipe, currentUser) {
                var idIngredientsLiked = currentUser.ingredientsLike,
                ingredientsMatched = [];

                recipesManager.get(recipe.slug, !recipe.nutriscore).then(function(recipeModel) {
                    //console.log('recipe retrieved', recipe);
                    recipeModel.ingredientsQuantity.forEach(function(ingredientQuantity) {
                        if (idIngredientsLiked.indexOf(ingredientQuantity.ingredient._id) > -1) {
                            ingredientsMatched.push(ingredientQuantity.ingredient);
                        }
                    });

                    recipe.ingredientsMatched = ingredientsMatched;
                    //console.log('ingredients Matched are',recipe.ingredientsMatched);
                });
            };
            
            if(!$stateParams.step) {
                //if searchData is not populated from url do it
                //update september 2020 - do it anyway
                //if(searchData.getTagsSelected().length === 0) {

                    //console.log('query params are', $stateParams.tags);
                    if($stateParams.tags) {
                        var extractedTagsFromUrl = $stateParams.tags.split(',');
                        searchData.setTagsSelected(extractedTagsFromUrl);
                        vm.tagsSelected = extractedTagsFromUrl;
                        //also apply it to the vm.tags data structure
                        vm.tagsSelected.forEach(function(tagName) {
                            vm.tags[tagName] = true;
                        });
                    }
                //}
                //else {
                    //TODO ? //do nothing ? call has been already made ?
                //}

                if($stateParams.search) {
                    vm.textSearch = $stateParams.search;
                    searchData.setTextSearch(vm.textSearch);
                    vm.tagsSelected = [];
                }
                vm._getAdvancedSearchResults();
            }

            vm.goToSearchStepOne = function() {
                $state.go('recipeSearchStep', {
                    step: '1'
                });
            };

            vm.goToSearchResultByText = function () {
                $state.go('recipeTextSearchResult', {
                    search: vm.textSearch
                });
            };



            var isSearchResultPage = $state.current.name.indexOf('SearchResult') > -1,
            stepNumber = parseInt($stateParams.step);
            
            context.set({
                href : !isSearchResultPage && stepNumber < 4 ?  this._getNextHref() : false,
                //TODO set iconcallback only if needed
                iconAction: isSearchResultPage ? (navigator && navigator.share ? 'share' : null) : 'arrow-left reversed bigger',
                iconCallback: (isSearchResultPage || stepNumber === 4) ? function() {
                    if (isSearchResultPage) {
                        navigator.share({
                            title: 'Moteur de recherche de recettes: votre prochain repas se trouve ici',
                            url : document.URL,
                            text: "Tiens, jète un oeil aux recettes que j'ai trouvées :)"
                        });
                    }
                    else {
                        this.gotoSearchResults();
                    }
                }.bind(this) : false,
                contextName : this._getContextName(),
                title : this._getTitle(),
                goBack: true
            });
            
            vm.onTagClicked = function(event) {
                var domTargetAttribute = event.target && event.target.closest('[tag]') && event.target.closest('[tag]').getAttribute('tag');
                if (domTargetAttribute) {
                    vm.tags[domTargetAttribute] = !vm.tags[domTargetAttribute];
                    if(vm.tags[domTargetAttribute]) {
                        switch(domTargetAttribute) {
                            case 'aperitif': vm.tags['entry'] = vm.tags['maincourse'] = vm.tags['dessert'] = false; break;
                            case 'entry': vm.tags['aperitif'] = vm.tags['maincourse'] = vm.tags['dessert'] = false; break;
                            case 'maincourse': vm.tags['aperitif'] = vm.tags['entry'] = vm.tags['dessert'] = false; break;
                            case 'dessert': vm.tags['aperitif'] = vm.tags['entry'] = vm.tags['maincourse'] = false; break;
                            case 'hot': vm.tags['cold'] = false; break;
                            case 'cold': vm.tags['hot'] = false; break;
                            case 'vegetarian' : vm.tags['vegan'] = true; vm.tags['nopig'] = true; break;
                            case 'vegan' : vm.tags['nopig'] = true; break;
                        }
                    }
                }
                vm._recomputeTags();
            };

            //TODO do a service to sort the tags by color
            var TAGS_BY_COLOR = ['complicated', 'nohob', 'protein', 'cold', 'eco', 'lowcarb', 'nopig', 'vegan', 'paleo', 'vegetarian','local', 'nogluten' , 'nooven', 'maincourse', 'nomicrowave',  'entry', 'pleasure', 'savory', 'aperitif', 'lowcalory',  'season', 'dessert', 'fast', 'sweet', 'hot'];

            vm._recomputeTags = function(advancedModeActivated) {
                //var previousTagsSelectedArray = vm.tagsSelected;
                
                vm.tagsSelected =[];
                
                Object.keys(vm.tags).forEach(function(key) {
                    if(vm.tags[key]) {
                        vm.tagsSelected.push(key);
                    }
                });
                //sort the tags by color
                vm.tagsSelected.sort(function(tag1, tag2) {
                    return TAGS_BY_COLOR.indexOf(tag2) - TAGS_BY_COLOR.indexOf(tag1);
                });

                if(advancedModeActivated) {
                    //silently change the URL for the result page with new tags
                    $state.go('recipeSearchResult', {tags: vm.tagsSelected.join(',')}); 
                    //$location.search('tags', vm.tagsSelected.join(','));
                    /**var path = $location.path(),
                    splittedPath = path.split('tags?');
                    
                    if(splittedPath) {
                        $location.path(splittedPath[0]+'tags?' +vm.tagsSelected.join(','));
                    }**/
                }

                searchData.setTagsSelected(vm.tagsSelected);

                if(vm.tagsSelected.length) {
                    if(typeof advancedModeActivated != 'undefined' && advancedModeActivated == true) {
                        //reinit page to 1 because results may have changed
                        vm.searchCurrentPage = 1;
                        // remove the previous thumb results and everyhing because it can take time to perform the call
                        vm.recipesResults = [];//init the array
                        vm.thumbRecipesResults = [];
                        vm._getAdvancedSearchResults();
                    }
                    else {
                        //here call for the recipes, and add some debounce to avoid many calls 
                        vm.debouncedSearch();
                    }
                }
                else {
                    vm.recipesCount = 0;
                    searchData.setRecipeCount(vm.recipesCount);
                    vm.updateCountOdometer();
                }
            };

            vm.debouncedSearch = utils.debounce(function() {
                recipesManager.searchRecipes(vm.tagsSelected)
                .then(function(count) {
                    vm.recipesCount = count;
                    searchData.setRecipeCount(count);
                    vm.updateCountOdometer();
                });
            }, 750);

            vm.updateCountOdometer = function() {
                var nodeEl;
                if (Odometer) {
                    if(!vm.odNumberRecipes) {
                        nodeEl = document.querySelector('.counter .number');
                        if(nodeEl) {
                            vm.odNumberRecipes = new Odometer({
                                el: nodeEl,
                                value: vm.recipesCount,
                                format: '( ddd),d',
                                theme: 'default'
                            });
                        } 
                    }
                    if(vm.odNumberRecipes) {
                        vm.odNumberRecipes.update(vm.recipesCount);
                    }
                }
            };

            vm.removeTag = function($event) {
                //to avoid apply digest cycle issue
                var tag = $event.target.getAttribute('tag-to-remove');
                if(tag && vm.tags[tag]) {
                    vm.tags[tag] = false;
                    console.log('the state is', $state, $state.current, $state.params);
                    //check if on result page or not with state params equal to 4
                    vm._recomputeTags($state.current.name === "recipeSearchResult");
                }
            };

            vm.onTagsSelected = function() {
                vm.tagsSelectedModalOpen = true;
            };

            vm.onModalClicked = function(event) {
                var target = event.target;
                if(target.classList.contains('tags-selected-modal')) {
                    vm.closeModal();
                }
            };

            vm.onModalRecipeSelectedClicked = function(event) {
                var target = event.target;
                if(target.classList.contains('tags-selected-modal')) {
                    vm.selectedRecipe = false;
                }
            };

            vm.closeModal = function() {
                vm.tagsSelectedModalOpen = false;
            };

            vm.ingredientsSearchResult = function(ingredientName) {
                //here return a promise
                //vm.isTypeAheadLoading = true;
                return ingredientsManager.searchAutocomplete(ingredientName)
                .then(function(results) {
                    //vm.isTypeAheadLoading = false;
                    console.log('results of ingredient search', results);
                    return results;
                }, function(err) {
                    console.log('erreur loading all profiles');
                    console.log(err);
                    //vm.isTypeAheadLoading = false;
                });
            };

            vm.typeaheadOnSelect = function(item, model, label, event) {
                vm.ingredientSearch = '';
                vm.isTypeAheadLoading = true;//not sure it it works 
                //here perform a call to the back end and get more info about this ingredient
                var slugOfIngredient = item.data[0];
                ingredientsManager.getQuick(slugOfIngredient).then(function(ingredient) {
                    vm.ingredients.unshift(ingredient);
                    vm.isTypeAheadLoading = false;
                    //$scope.$apply();//needs this because asynchronous
                    //check if this ingredient is liked or not by the current user
                    ingredient.getInteractions()
                    .then(function(data) {
                        ingredient.interactions = data;
                        console.log('the api interactions on ingredient succeeded', data);
                    }, function() {
                        console.log('the api like on ingredient failed');
                    });
                    /**.error(function() {
                        console.log('the api like on ingredient failed');
                    });*/
                });
                //then push it to the ingredients list
                //console.log(item, model, label, event);
            };

            vm.onLikeIngredient = function(ingredient) {
                if (ingredient.interactions.isLiked ) {
                    ingredient.unlike();
                    currentUser.get().then(function(userModel) {
                        userModel.ingredientsLike = userModel.ingredientsLike.filter(function(ingredientId) {
                            return ingredientId !== ingredient._id;
                        });
                    });
                }
                else {
                    ingredient.interactions.isDisliked = false;
                    ingredient.like();
                    currentUser.get().then(function(userModel) {
                        userModel.ingredientsLike.push(ingredient._id);
                        userModel.ingredientsDislikes = userModel.ingredientsDislikes.filter(function(ingredientId) {
                            return ingredientId !== ingredient._id;
                        });
                    });
                }
                ingredient.interactions.isLiked = !ingredient.interactions.isLiked;
            };  

            //Used to remove a like on some ingredient
            vm.unlikeIngredient = function(ingredient, index) {
                //ingredient.unlike();
                vm.ingredientsLikedArray.splice(index, 1);
                ingredient.unlike();
                currentUser.get().then(function(userModel) {
                    userModel.ingredientsLike = userModel.ingredientsLike.filter(function(ingredientId) {
                        return ingredientId !== ingredient._id;
                    });
                });
            };

            vm.unDislikeIngredient = function(ingredient, index) {
                vm.ingredientsDislikedArray.splice(index, 1);
                ingredient.undislike();
                currentUser.get().then(function(userModel) {
                    userModel.ingredientsDislikes = userModel.ingredientsDislikes.filter(function(ingredientId) {
                        return ingredientId !== ingredient._id;
                    });
                });
            };
        
            vm.ondislikeIngredient = function(ingredient) {
                if (ingredient.interactions.isDisliked) {
                    ingredient.undislike();
                    currentUser.get().then(function(userModel) {
                        userModel.ingredientsDislikes = userModel.ingredientsDislikes.filter(function(ingredientId) {
                            return ingredientId !== ingredient._id;
                        });
                    });
                }
                else {
                    ingredient.interactions.isLiked = false;
                    ingredient.dislike();
                    currentUser.get().then(function(userModel) {
                        userModel.ingredientsDislikes.push(ingredient._id);
                        userModel.ingredientsLike = userModel.ingredientsLike.filter(function(ingredientId) {
                            return ingredientId !== ingredient._id;
                        });
                    });
                }
                ingredient.interactions.isDisliked = !ingredient.interactions.isDisliked;
            };

            vm.getAllergens = function() {

                currentUser.get().then(function(userModel) {
                    if (userModel && userModel._id) {
                        var deferred = $q.defer();
                
                        allergensManager.getAll()
                        .then(function(result) {
                            
                            vm.allergens = result.collection;
                            vm._populateAllergensUserList();
                            //parse the collection
                            deferred.resolve([]);
                        }, function(err) {
                            console.log('error loading all allergens');
                        });
                    
                        return deferred.promise;
                    }
                }, function() {
                    //do nothing in this case
                    //vm.noAccount = true;
                });
            };

            vm.getIngredientsLiked = function(){
                currentUser.get().then(function(userModel) {
                    userModel.getIngredientsLiked(vm.currentIngredientPage).then(function(ingredients) {
                        vm.ingredientsLikedArray = ingredients;
                    });
                });
            };  

            vm.getIngredientsDisliked = function() {
                currentUser.get().then(function(userModel) {
                    userModel.getIngredientsDisliked(vm.currentIngredientDislikePage).then(function(ingredients) {
                        vm.ingredientsDislikedArray = ingredients;
                    });
                });
            };
            
            vm.onAllergenChange = function() {
                var model = vm.listAllergensForCurrentUser.filter(function(allergen) {
                    return allergen._id === vm.allergen;//contains the ID selected
                });
                //add it if not already added
                if(model.length === 0) {
                    model = vm.allergens.filter(function(allergen) {
                        return allergen._id === vm.allergen;//contains the ID selected
                    });
                    
                    vm.listAllergensForCurrentUser.push(model[0]);
                    currentUser.get().then(function(userModel) {
                        userModel.addAllergen(vm.allergen).then(function() {
                            console.log('allergenAdded');
                        }, function() {
                            //TODO remove the allergen
                            alertMatt.push('danger', 'Une erreur est survenue, merci de réessayer ultérieurement.');
                        });
                    });
                }
            };

            //function to compute and populate allergens for the current user
            vm._populateAllergensUserList = function() {
                currentUser.get().then(function(userModel) {
                    userModel.allergens.forEach(function(allergenId) {
                        vm.allergens.forEach(function(allergenModel) {
                            if(allergenModel._id === allergenId) {
                                vm.listAllergensForCurrentUser.push(allergenModel);
                            }
                        });
                    });
                });
            };

            vm.onAllergenRemove = function(allergenModel) {
                //search allergen in arrat and remove it
                vm.listAllergensForCurrentUser = vm.listAllergensForCurrentUser.filter(function(allergen) {
                    return allergen._id !== allergenModel._id;
                });

                currentUser.get().then(function(userModel) {
                    userModel.deleteAllergen(allergenModel._id).then(function() {
                        console.log('allergenremved');
                    }, function() {
                        //TODO remove the allergen
                        alertMatt.push('danger', 'Une erreur est survenue, merci de réessayer ultérieurement.');
                    });
                });
            };

            vm.displaySubscribeLayer = function() {
                loginModal.open(false);//false means this is for registering
                var modalInstance = loginModal.get();
                modalInstance.closed.then(function() {
                    //vm.noAccount = false;//not enough i think we need to reload the page or at least the controller
                    $state.reload();
                });
            };

            //extract tags from recipe that match the request
            vm.getTagsThatMatchSearchRequest = function(recipe) {
                return recipe ? recipe.tags.filter(function(n) {
                    return vm.tagsSelected.indexOf(n) !== -1;
                }) : [];
            };

            vm.getAlmostTagsThatMatchSearchRequest = function(recipe) {
                return recipe ? recipe.almostTags.filter(function(n) {
                    return vm.tagsSelected.indexOf(n) !== -1;
                }) : [];
            };

            vm.goToRecipe = function(slug) {
                $state.go('recipe', {
                    id: slug
                });
            };

            vm.goToRecipeCreation = function() {
                $state.go('recipecreation');
            };

            vm.gotoSearchResults = function() {
                //only go to search results if there is at least one tag selected
                if (vm.tagsSelected.length === 0) {
                    alertMatt.push('info', 'Veuillez sélectionner au moins 1 tag');
                    //specific case when not connected and no tag selected go back to step 1 to select at least one tag
                    if(vm.noAccount) {
                        $state.go('recipeSearchStep', {
                            'step': '1'
                        });
                    }
                }
                else {
                    $state.go('recipeSearchResult', {
                        'tags': vm.tagsSelected.join(',')
                    });
                } 
            };

            vm.selectRecipe= function(recipe, event) {
                event.preventDefault();
                event.stopPropagation();
                vm.selectedRecipe = recipe;
            };

            vm.displayHelp = function(boolean, event) {
                event.preventDefault();
                event.stopPropagation();
                vm.isHelpDisplayed = boolean;
                vm.mustDisplayHelp = false;
                $window.localStorage['searchHelp'] = false;
            };

            vm.loadMore = function() {
                vm.searchCurrentPage++;
                vm._getAdvancedSearchResults();
            };

            //TODO what is this functon used for ?
            vm.onTagPressed = function() {
                alertMatt.push('success', 'button pressed');
                //call a service to display the info on the modal OR navigate to another page (if on desktop ?)
                //javascript detect if mobile or not`
            };  
        }
  })();